module.exports = __webpack_public_path__ + "static/media/load.a92ec81d.gif";